<template>
  <CFooter :fixed="false">
    <div>
      <span>Footer</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
